"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var skynet_store_languages_api_1 = require("@synisys/skynet-store-languages-api");
var skynet_store_messages_api_1 = require("@synisys/skynet-store-messages-api");
var skynet_store_utilities_1 = require("@synisys/skynet-store-utilities");
var of_1 = require("rxjs/observable/of");
var zip_1 = require("rxjs/observable/zip");
var meta_field_1 = require("../model/meta-field");
var kb_deserialization_helper_1 = require("./kb-deserialization-helper");
var meta_category_1 = require("../model/meta-category");
var meta_field_id_1 = require("../model/meta-field-id");
var meta_category_id_1 = require("../model/meta-category-id");
var Observable_1 = require("rxjs/Observable");
var operators_1 = require("rxjs/operators");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var meta_group_id_1 = require("../model/meta-group-id");
var operators_2 = require("rxjs/operators");
var store_1 = require("@ngrx/store");
var skynet_store_kb_api_1 = require("@synisys/skynet-store-kb-api");
var meta_field_type_helper_1 = require("./meta-field-type-helper");
var lodash_1 = require("lodash");
var KbHttpService = /** @class */ (function () {
    function KbHttpService(http, store, applicationPropertiesService) {
        this.http = http;
        this.store = store;
        this.applicationPropertiesService = applicationPropertiesService;
        this.kbApiUrlKey = 'kb-service-url';
        this.cacheKeyAllCategories = 'allCategories';
        this.cacheKeyClassifierCategories = 'classifierCategories';
        this.cacheKeyMainEntityCategories = 'mainEntityCategories';
        this.cacheKeyCategoryManagerCategories = 'categoryCategories';
        this.cacheKeyHierarchicalCategories = 'hierarchicalcategories';
        this.urlLoadCategory = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_1 || (templateObject_1 = __makeTemplateObject(["", "/categories/", ""], ["", "/categories/", ""])), "serviceUri", "categorySystemName");
        this.urlLoadCategoryWithCustomPrefix = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", "/", "/categories/", ""], ["", "/", "/categories/", ""])), "serviceUri", "customPrefix", "categorySystemName");
        this.urlLoadCategories = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", "/categories"], ["", "/categories"])), "serviceUri");
        this.urlLoadCategoriesWithCustomPrefix = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", "/", "/categories"], ["", "/", "/categories"])), "serviceUri", "customPrefix");
        this.urlLoadHierarchicalCategories = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", "/hierarchicalcategories"], ["", "/hierarchicalcategories"])), "serviceUri");
        this.urlLoadHierarchicalCategoriesWithCustomPrefix = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", "/", "/hierarchicalcategories"], ["", "/", "/hierarchicalcategories"])), "serviceUri", "customPrefix");
        this.urlLoadMainEntityCategoryFields = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", "/mainentityfields/", "/", ""], ["", "/mainentityfields/", "/", ""])), "serviceUri", "categorySystemName", "fieldSystemName");
        this.urlLoadMainEntityCategoryFieldsWithCustomPrefix = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", "/", "/mainentityfields/", "/", ""], ["", "/", "/mainentityfields/", "/", ""])), "serviceUri", "customPrefix", "categorySystemName", "fieldSystemName");
        this.cachedData = new Map();
        this.kbDeserializationHelper = new kb_deserialization_helper_1.KbDeserializationHelper();
        this.kbServiceUrl$ = Observable_1.Observable.from(this.applicationPropertiesService.getProperty(this.kbApiUrlKey));
    }
    KbHttpService_1 = KbHttpService;
    KbHttpService.prototype.getCategories = function () {
        return this.getAllMetaCategories();
    };
    KbHttpService.prototype.getAllMetaCategories = function (customPrefix) {
        return skynet_store_kb_api_1.categoryStoreManager(customPrefix)
            .selectAll(this.store)
            .pipe(operators_1.map(function (values) { return new Set(values.map(function (item) { return fromStoreMetaCategory(item); }).valueSeq().toArray()); }));
    };
    KbHttpService.prototype.getClassifierMetaCategories = function (customPrefix) {
        return this.getMetaCategories(this.cacheKeyClassifierCategories, kb_deserialization_helper_1.CategoryType.CLASSIFIER, customPrefix);
    };
    KbHttpService.prototype.getMainEntityMetaCategories = function (customPrefix) {
        return this.getMetaCategories(this.cacheKeyMainEntityCategories, kb_deserialization_helper_1.CategoryType.MAIN_ENTITY, customPrefix);
    };
    KbHttpService.prototype.getCategoryManagerMetaCategories = function (customPrefix) {
        return this.getMetaCategories(this.cacheKeyCategoryManagerCategories, kb_deserialization_helper_1.CategoryType.CATEGORY_MANAGER, customPrefix);
    };
    KbHttpService.prototype.getMetaCategoryByMetaCategoryId = function (metaCategoryId, customPrefix) {
        var categorySystemName = metaCategoryId.getSystemName();
        return skynet_store_kb_api_1.categoryStoreManager(customPrefix)
            .selectAll(this.store)
            .pipe(operators_1.map(function (values) { return values.map(function (item) { return fromStoreMetaCategory(item); })
            .valueSeq()
            .find(function (item) { return item.getSystemName()
            .toLowerCase() === categorySystemName.toLowerCase(); }); }));
    };
    KbHttpService.prototype.getMetaFields = function (categorySystemName, customPrefix) {
        return skynet_store_kb_api_1.fieldStoreManager(customPrefix).selectAll(this.store, categorySystemName)
            .pipe(operators_1.map(function (list) {
            return list.map(function (item) { return fromStoreMetaField(item); }).valueSeq()
                .toArray();
        }));
    };
    KbHttpService.prototype.getNonSystemMetaFields = function (categorySystemName, customPrefix) {
        return this.getMetaFields(categorySystemName, customPrefix).map(function (metaFields) {
            return metaFields.filter(function (item) {
                return !item.getIsSystemField();
            });
        });
    };
    KbHttpService.prototype.getMainEntityMetaFields = function (categorySystemName, mainEntityMetaFieldSystemName, customPrefix) {
        var _this = this;
        var cacheKey = categorySystemName + "-" + mainEntityMetaFieldSystemName + "MainEntityFields" + customPrefix;
        if (!this.cachedData.get(cacheKey)) {
            this.cachedData.set(cacheKey, this.kbServiceUrl$
                .mergeMap(function (kbServiceUrl) {
                var urlTemplate = !customPrefix ?
                    _this.urlLoadMainEntityCategoryFields :
                    _this.urlLoadMainEntityCategoryFieldsWithCustomPrefix;
                var url = urlTemplate.replaceTemplate({
                    'serviceUri': kbServiceUrl,
                    'categorySystemName': categorySystemName,
                    'fieldSystemName': mainEntityMetaFieldSystemName,
                    'customPrefix': customPrefix
                });
                return _this.http.get(url)
                    .pipe(operators_1.mergeMap(function (response) {
                    if (response.length === 0) {
                        return of_1.of([]);
                    }
                    return zip_1.zip.apply(void 0, response.map(function (item) { return _this.correctNameOfEntity(item); }));
                }), operators_1.map(function (response) {
                    return _this.kbDeserializationHelper.extractFields(categorySystemName, response);
                }));
            }).pipe(operators_2.shareReplay(1)));
        }
        return this.cachedData.get(cacheKey);
    };
    KbHttpService.prototype.getMetaFieldByMetaFieldId = function (metaFieldId, customPrefix) {
        return skynet_store_kb_api_1.fieldStoreManager(customPrefix).selectAll(this.store, metaFieldId.getMetaCategoryId().getSystemName())
            .pipe(operators_1.map(function (list) { return fromStoreMetaField(list.findLast(function (item) { return item.metaFieldId.systemName ===
            metaFieldId.getSystemName(); })); }));
    };
    KbHttpService.prototype.getMetaGroups = function (categorySystemName, customPrefix) {
        return this.getNonSystemMetaGroups(categorySystemName, customPrefix);
    };
    KbHttpService.prototype.getAllMetaGroups = function (categorySystemName, customPrefix) {
        var _this = this;
        return skynet_store_kb_api_1.groupStoreManager(customPrefix).selectAll(this.store, categorySystemName).pipe(operators_1.switchMap(function (groups) { return _this.kbDeserializationHelper.extractGroups(_this.getMetaFields(categorySystemName), groups, false); }));
    };
    KbHttpService.prototype.getNonSystemMetaGroups = function (categorySystemName, customPrefix) {
        var _this = this;
        return skynet_store_kb_api_1.groupStoreManager(customPrefix).selectAll(this.store, categorySystemName).pipe(operators_1.switchMap(function (groups) { return _this.kbDeserializationHelper.extractGroups(_this.getMetaFields(categorySystemName), groups, true); }));
    };
    KbHttpService.prototype.getHierarchicalMetaCategoryIds = function (customPrefix) {
        var _this = this;
        var cacheKey = "" + this.cacheKeyHierarchicalCategories + customPrefix;
        if (!this.cachedData.get(cacheKey)) {
            this.cachedData.set(cacheKey, this.kbServiceUrl$.mergeMap(function (kbServiceUrl) {
                var urlTemplate = !customPrefix ? _this.urlLoadHierarchicalCategories :
                    _this.urlLoadHierarchicalCategoriesWithCustomPrefix;
                var url = urlTemplate.replaceTemplate({
                    "serviceUri": kbServiceUrl,
                    "customPrefix": customPrefix
                });
                return _this.http.get(url).map(function (responseData) {
                    return _this.extractHierarchicalMetaCategories(responseData);
                });
            })
                .pipe(operators_2.shareReplay(1))
                .catch(this.handleError));
        }
        return this.cachedData.get(cacheKey);
    };
    KbHttpService.prototype.getMetaCategories = function (categoryCacheKey, categoryType, customPrefix) {
        var _this = this;
        return skynet_store_kb_api_1.categoryStoreManager(customPrefix)
            .selectAll(this.store).pipe(operators_1.map(function (values) {
            return _this.extractMetaCategories(values.map(function (item) { return fromStoreMetaCategory(item); }).valueSeq().toList(), categoryType);
        }));
    };
    KbHttpService.prototype.extractMetaFieldId = function (metaFieldIdJson) {
        return this.kbDeserializationHelper.extractMetaFieldId(metaFieldIdJson);
    };
    KbHttpService.prototype.getDisplayNameMetaFields = function (categorySystemName) {
        return Observable_1.Observable.from([]);
    };
    KbHttpService.prototype.getNameMetaFieldIds = function (categorySystemName, customPrefix) {
        return this.getMetaCategoryByMetaCategoryId(new meta_category_id_1.MetaCategoryId(categorySystemName), customPrefix)
            .map(function (metaCategory) {
            return metaCategory.getNameMetaFieldIds();
        });
    };
    KbHttpService.prototype.getKeyMetaFieldIds = function (categorySystemName, customPrefix) {
        return this.getMetaCategoryByMetaCategoryId(new meta_category_id_1.MetaCategoryId(categorySystemName), customPrefix)
            .map(function (metaCategory) {
            return metaCategory.getKeyMetaFieldIds();
        });
    };
    KbHttpService.prototype.getClassifierViewMetaFields = function () {
        return Observable_1.Observable.from([
            [
                new meta_field_1.MetaField(new meta_field_id_1.MetaFieldId(new meta_category_id_1.MetaCategoryId(""), "id", new meta_group_id_1.MetaGroupId("general")), "kb_id", meta_field_1.MetaFieldType.INTEGER_IDENTITY, "INTEGER_IDENTITY", false),
                new meta_field_1.MetaField(new meta_field_id_1.MetaFieldId(new meta_category_id_1.MetaCategoryId(""), "name", new meta_group_id_1.MetaGroupId("general")), "kb_name", meta_field_1.MetaFieldType.STRING, "STRING", false)
            ]
        ]);
    };
    KbHttpService.prototype.getAncestorsMetaCategoryIds = function (metaCategoryId) {
        var _this = this;
        return this.getMetaFields(metaCategoryId.getSystemName())
            .flatMap(function (metaFields) {
            var parentCategory = metaFields.find(function (metaField) {
                return metaField.getType() === meta_field_1.MetaFieldType.PARENT;
            });
            if (parentCategory) {
                var parentCategorySystemName = parentCategory.getCompoundCategorySystemName();
                var parentMetaCategoryId_1 = new meta_category_id_1.MetaCategoryId(parentCategorySystemName);
                return _this.getAncestorsMetaCategoryIds(parentMetaCategoryId_1)
                    .map(function (ancestors) {
                    ancestors.unshift(parentMetaCategoryId_1);
                    return ancestors;
                });
            }
            return Observable_1.Observable.of([]);
        });
    };
    KbHttpService.prototype.getIdentityMetaField = function (categorySystemName, customPrefix) {
        return this.getMetaFields(categorySystemName, customPrefix)
            .map(function (metaFields) {
            var identity = metaFields.find(function (metaField) {
                return metaField.getType() === meta_field_1.MetaFieldType.INTEGER_IDENTITY;
            });
            if (!identity) {
                throw new Error(categorySystemName + " category doesn't have identity metaField");
            }
            return identity;
        });
    };
    KbHttpService.prototype.getInstanceMetaField = function (categorySystemName, customPrefix) {
        return this.getMetaFields(categorySystemName, customPrefix)
            .map(function (metaFields) {
            var instance = metaFields.find(function (metaField) {
                return metaField.getType() === meta_field_1.MetaFieldType.INTEGER_INSTANCE;
            });
            return instance ? instance : null;
        });
    };
    KbHttpService.prototype.getWorkflowStateMetaField = function (categorySystemName, customPrefix) {
        return this.getMetaFields(categorySystemName, customPrefix)
            .map(function (metaFields) {
            var wfState = metaFields.find(function (metaField) {
                return metaField.getType() === meta_field_1.MetaFieldType.WORKFLOW_STATE;
            });
            return wfState ? wfState : null;
        });
    };
    KbHttpService.prototype.getWorkflowActionMetaFieldId = function (metaCategoryId, customPrefix) {
        return new meta_field_id_1.MetaFieldId(metaCategoryId, KbHttpService_1.WORKFLOW_ACTION_ID_SYSTEM_NAME, null);
    };
    KbHttpService.prototype.resetCache = function () {
        this.cachedData = new Map();
    };
    KbHttpService.prototype.extractMetaCategories = function (responseData, categoryType) {
        return this.kbDeserializationHelper.extractCategories(responseData, categoryType);
    };
    KbHttpService.prototype.extractHierarchicalMetaCategories = function (responseData) {
        return this.kbDeserializationHelper.extractHierarchicalCategories(responseData);
    };
    KbHttpService.prototype.handleError = function (error) {
        var errMsg = (error.message) ? error.message :
            error.status ? error.status + " - " + error.statusText : 'Server error';
        console.error(errMsg);
        return Observable_1.Observable.throw(errMsg);
    };
    KbHttpService.prototype.getUrlForCategory = function (serviceUrl, customPrefix, categorySystemName) {
        if (categorySystemName) {
            var urlTemplate_1 = !customPrefix ? this.urlLoadCategory
                : this.urlLoadCategoryWithCustomPrefix;
            return urlTemplate_1.replaceTemplate({
                "serviceUri": serviceUrl,
                "customPrefix": customPrefix,
                "categorySystemName": categorySystemName
            });
        }
        var urlTemplate = !customPrefix ? this.urlLoadCategories
            : this.urlLoadCategoriesWithCustomPrefix;
        return urlTemplate.replaceTemplate({
            "serviceUri": serviceUrl,
            "customPrefix": customPrefix,
        });
    };
    KbHttpService.prototype.correctNameOfEntity = function (entityWithName) {
        if (skynet_store_utilities_1.isEmptyMultilingual(entityWithName.displayNameMultilingual) &&
            !lodash_1.isNil(entityWithName.displayName)) {
            return this.convertMessageToMultilingual(entityWithName.displayName).pipe(operators_1.map(function (name) {
                entityWithName.displayNameMultilingual = name;
                return entityWithName;
            }));
        }
        else if (lodash_1.isNil(entityWithName.displayNameMultilingual) &&
            lodash_1.isNil(entityWithName.displayName)) {
            entityWithName.displayNameMultilingual = idm_crosscutting_concepts_frontend_1.MultilingualString.newBuilder().build();
            return of_1.of(entityWithName);
        }
        else {
            return of_1.of(entityWithName);
        }
    };
    KbHttpService.prototype.convertMessageToMultilingual = function (name) {
        var _this = this;
        return skynet_store_languages_api_1.languageStoreManager.selectAll(this.store).pipe(operators_1.distinctUntilChanged(function (a, b) { return a.equals(b); }), operators_1.map(function (languages) {
            return languages
                .toSeq()
                .map(function (language) { return language.getId(); })
                .map(function (languageId) { return skynet_store_messages_api_1.MessageKeyFactory({ name: name, languageId: languageId }); });
        }), operators_1.switchMap(function (keys) {
            return zip_1.zip.apply(void 0, keys
                .map(function (key) {
                return skynet_store_messages_api_1.messageStoreManager
                    .selectOne(_this.store, key)
                    .pipe(operators_1.filter(skynet_store_utilities_1.notNil));
            })
                .toList()
                .toArray());
        }), operators_1.map(function (messages) {
            return messages
                .reduce(function (builder, message) {
                return builder.withValueForLanguage(message.key.languageId, message.value);
            }, idm_crosscutting_concepts_frontend_1.MultilingualString.newBuilder())
                .build();
        }));
    };
    KbHttpService.WORKFLOW_ACTION_ID_SYSTEM_NAME = "lastActionId";
    KbHttpService = KbHttpService_1 = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_authentication_client_js_1.HttpClientWrapper,
            store_1.Store,
            idm_application_properties_service_client_js_1.ApplicationPropertiesService])
    ], KbHttpService);
    return KbHttpService;
    var KbHttpService_1;
}());
exports.KbHttpService = KbHttpService;
var fromStoreMetaFieldId = function (storeMetaFieldId) {
    return new meta_field_id_1.MetaFieldId(new meta_category_id_1.MetaCategoryId(storeMetaFieldId.metaCategoryId.systemName), storeMetaFieldId.systemName, new meta_group_id_1.MetaGroupId(storeMetaFieldId.groupId.systemName));
};
var fromStoreCompoundSystemName = function (storeMetaField) {
    if (!lodash_1.isNil(storeMetaField.lookupMetaCategoryId))
        return storeMetaField.lookupMetaCategoryId.systemName;
    if (!lodash_1.isNil(storeMetaField.classifierMetaCategoryId))
        return storeMetaField.classifierMetaCategoryId.systemName;
    if (!lodash_1.isNil(storeMetaField.documentMetaCategoryId))
        return storeMetaField.documentMetaCategoryId.systemName;
    if (!lodash_1.isNil(storeMetaField.mainEntityCategoryId))
        return storeMetaField.mainEntityCategoryId.systemName;
    if (!lodash_1.isNil(storeMetaField.workflowStateMetaCategoryId))
        return storeMetaField.workflowStateMetaCategoryId.systemName;
    if (!lodash_1.isNil(storeMetaField.parentMetaCategoryId))
        return storeMetaField.parentMetaCategoryId.systemName;
    if (!lodash_1.isNil(storeMetaField.subEntityMetaCategoryId))
        return storeMetaField.subEntityMetaCategoryId.systemName;
};
var fromStoreMetaField = function (storeMetaField) {
    var typeHelper = new meta_field_type_helper_1.MetaFieldTypeHelper();
    return new meta_field_1.MetaField(fromStoreMetaFieldId(storeMetaField.metaFieldId), storeMetaField.displayName, typeHelper.getMetaFieldType(storeMetaField.metaFieldType), storeMetaField.metaFieldType, storeMetaField.isMultiline, fromStoreCompoundSystemName(storeMetaField), storeMetaField.maxLength, storeMetaField.fieldPrefix, storeMetaField.isSystemField, storeMetaField[skynet_store_kb_api_1.ENTITY_MULTILINGUAL_NAME_ATTRIBUTE], storeMetaField.isActionDataField, storeMetaField.isTransient);
};
var fromStoreMetaCategory = function (storeMetaCategory) {
    return new meta_category_1.MetaCategory(new meta_category_id_1.MetaCategoryId(storeMetaCategory.metaCategoryId.systemName), storeMetaCategory.displayName, storeMetaCategory.hasCustomSorting, storeMetaCategory.hasIcon, undefined, Number(storeMetaCategory.wfProcessId), storeMetaCategory.isCacheable, !lodash_1.isNil(storeMetaCategory.nameMetaFieldIds) ?
        storeMetaCategory.nameMetaFieldIds.map(function (item) { return fromStoreMetaFieldId(item); }).valueSeq().toArray() :
        undefined, storeMetaCategory.isWithVersioning, storeMetaCategory.isClassifier, !lodash_1.isNil(storeMetaCategory.keyMetaFieldIds) ?
        storeMetaCategory.keyMetaFieldIds.map(function (item) { return fromStoreMetaFieldId(item); }).valueSeq().toArray() :
        undefined, !lodash_1.isNil(storeMetaCategory.actionDataMetaFieldIds) ?
        storeMetaCategory.actionDataMetaFieldIds.map(function (item) { return fromStoreMetaFieldId(item); }).valueSeq().toArray() :
        undefined, !lodash_1.isNil(storeMetaCategory.transientMetaFieldIds) ?
        storeMetaCategory.transientMetaFieldIds.map(function (item) { return fromStoreMetaFieldId(item); }).valueSeq().toArray() :
        undefined, storeMetaCategory[skynet_store_kb_api_1.ENTITY_MULTILINGUAL_NAME_ATTRIBUTE], storeMetaCategory.showInCategoryManager, lodash_1.isNil(storeMetaCategory.searchableFieldIds) ?
        undefined :
        storeMetaCategory.searchableFieldIds.map(function (item) { return fromStoreMetaFieldId(item); }).toArray(), storeMetaCategory.isRoot);
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
//# sourceMappingURL=kb-http.service.js.map